module.exports = __webpack_public_path__ + "img/course_006.9346731.webp";